import React, { useState, useRef, useEffect, memo } from "react";
import { HeaderMain } from "../customer/styles/HeaderStyles";
// import SelectDate from "../shared/SelectDate";
// import SearchMain from "../shared/SearchMain";
import { InvoiceButton, AccountingHeader } from "./styles/InvoiceStyles";
import GenerateInvoicesPopup from "./GenerateInvoicesPopup";
import {
  SearchButton,
  SearchClean,
  SearchInputMain,
} from "../shared/styles/SearchStyle";
import { IconButton } from "@mui/material";
import search from "../../../assets/images/search.svg";
import {
  CleanButton,
  DateMain,
  DateStyleBtn,
  DateWrapper,
} from "../shared/styles/SelectDateStyle";
import ClearIcon from "@mui/icons-material/Clear";
import calendar from "../../../assets/images/calendar.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const Header = ({
  Placeholder = "",
  SearchInputValue = "",
  setSearchInputValue = () => {},
  setCurrentPage = () => {},
  SelectedDateCallback = "",
  setSelectedDateCallback = () => {},
}) => {
  const Showplaceholder = Placeholder || "Search Messages";

  const [searchText, setSearchText] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const datepickerRef = useRef(null);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  //  ================= Search  =================

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleButtonClick = () => {
    setSearchInputValue(searchText);
    setCurrentPage(1);
  };
  const CleanHandleClick = () => {
    setSearchInputValue("");
    setSearchText("");
  };

  //  ================= End Search  =================

  //  =================   Date Popup  =================

  const handleDateClick = () => {
    setShowDatePicker(true);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
    const formattedDate = moment(date).format("DD/MM/YYYY");
    setSelectedDateCallback(formattedDate);
  };

  const handleClickOutside = (event) => {
    if (
      datepickerRef.current &&
      !datepickerRef.current.contains(event.target)
    ) {
      setShowDatePicker(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const CleanHandleDateClick = () => {
    setSelectedDateCallback("");
  };

  //  =================  End Date Popup  =================

  return (
    <>
      <AccountingHeader>
        <HeaderMain>
          <SearchInputMain>
            <img src={search} alt="search" />
            <input
              type="text"
              placeholder={Showplaceholder}
              value={searchText}
              onChange={handleInputChange}
            />
            {searchText && (
              <IconButton onClick={handleButtonClick}>
                <SearchButton />
              </IconButton>
            )}
            {searchText && (
              <IconButton onClick={CleanHandleClick}>
                <SearchClean />
              </IconButton>
            )}
          </SearchInputMain>
          {/* <SearchMain placeholder="Search for AWB, name, order status or something..." /> */}
          {/* <SelectDate /> */}

          <DateMain>
            <DateStyleBtn onClick={handleDateClick}>
              <img src={calendar} alt="calendar" />
              {!SelectedDateCallback ? "Select Date" : SelectedDateCallback}
            </DateStyleBtn>
            {SelectedDateCallback && (
              <CleanButton onClick={CleanHandleDateClick}>
                <ClearIcon />
              </CleanButton>
            )}
          </DateMain>
          {showDatePicker && (
            <DateWrapper className="customer__dateinputs" ref={datepickerRef}>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                showPopperArrow={false}
                inline
              />
            </DateWrapper>
          )}
        </HeaderMain>
        <InvoiceButton onClick={handleOpenDialog}>New Invoice</InvoiceButton>
      </AccountingHeader>
      <GenerateInvoicesPopup
        open={openDialog}
        handleClose={handleCloseDialog}
      />
    </>
  );
};

export default memo(Header);
